<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pVEAm5/tc-custom/9781473891111.jpg?1709191531971" alt="This image is the cover for the book T-54/55, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">T-54/55, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <p>The Soviet T-54/55 is probably the best-known tank of the Cold War, and it was produced in greater numbers that any other tank in history. It first went into service just after the Second World War and over 70,000 were made, and its design was so successful that it even outlasted its successor the T-62. For a generation it formed the backbone of the armored forces of the Warsaw Pact and it was exported all over the world, remaining in the front-line until the 1990s. This photographic history in the Images of War series by Anthony Tucker-Jones is the ideal introduction to it. In over 150 archive photographs and a detailed analytical text, he traces the design and development of the T-54/55 and records its operational history. He describes how it was conceived as a main battle tank, an all-rounder, contrasting with the light, medium and heavy tanks produced in the past, and it proved to be extraordinarily effective. It was as adaptable as it was long-lasting, different versions being produced by China, Czechoslovakia, Poland and Romania. Its relatively simple design also meant it was easy to maintain even in difficult conditions and it was used by armies across the Third World, in particular in wars in Angola, Ethiopia, Mozambique and Somalia. Anthony Tucker-Jones's history of this remarkable armored vehicle will be absorbing reading for tank enthusiasts and a valuable source for modelers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Tucker-Jones
      </h2>
      
      <p class="authorDescription body article">Anthony Tucker-Jones is a former defence intelligence officer and a widely published expert on regional conflicts, counter-terrorism and armoured and aerial warfare. He is the author of over thirty books including Falaise: The Flawed Victory, Operation Dragoon: The Liberation of Southern France 1944, Armoured Warfare on the Eastern Front, Tiger I & Tiger II, T-34: The Red Army's Legendary Medium Tank, The Panther Tank: Hitler's T-34 Killer, The Battle for Budapest 1944–1945 and The Panzer IV: Hitler's Rock. He is security and terrorism correspondent for intersec – The Journal of International Security and has freelanced for Channel 4 News. For further information his website can be found at www.atuckerjones.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eab44aa0